import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail, X } from "lucide-react";
import { WhatsAppIcon } from "./Logo";
import { waLink, mailLink, telLink, BRAND } from "../lib/brand";

export const FloatingWhatsApp = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-4 sm:right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="w-64 rounded-2xl bg-[#faf9f5] border border-[#e7e3d7] shadow-[0_24px_60px_-20px_rgba(19,19,17,0.4)] overflow-hidden"
          >
            <div className="bg-[#131311] px-4 py-3">
              <div className="font-serif text-lg text-[#faf3e0] leading-tight">
                Laxmi Jiwan Properties
              </div>
              <div className="text-[11px] text-[#c5a059]">Typically replies within minutes</div>
            </div>
            <div className="p-3 flex flex-col gap-2">
              <a
                href={waLink("Hello Laxmi Jiwan Properties, I have a query about a property in Hisar.")}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 rounded-xl bg-[#25d366]/10 hover:bg-[#25d366]/20 px-3 py-2.5 transition-colors"
              >
                <WhatsAppIcon className="h-5 w-5 text-[#1eae53]" />
                <span className="text-sm font-semibold text-[#131311]">WhatsApp Chat</span>
              </a>
              <a
                href={telLink}
                className="flex items-center gap-3 rounded-xl hover:bg-[#f4efdf] px-3 py-2.5 transition-colors"
              >
                <Phone className="h-5 w-5 text-[#9a7b38]" />
                <span className="text-sm font-semibold text-[#131311]">{BRAND.phoneDisplay}</span>
              </a>
              <a
                href={mailLink()}
                className="flex items-center gap-3 rounded-xl hover:bg-[#f4efdf] px-3 py-2.5 transition-colors"
              >
                <Mail className="h-5 w-5 text-[#9a7b38]" />
                <span className="text-sm font-semibold text-[#131311]">Email Us</span>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((v) => !v)}
        className={`lj-pulse h-14 w-14 rounded-full grid place-items-center text-white shadow-[0_12px_30px_rgba(37,211,102,0.4)] transition-colors duration-300 ${
          open ? "bg-[#131311]" : "bg-[#25d366] hover:bg-[#1eae53]"
        }`}
        data-testid="sticky-whatsapp-float-button"
        aria-label="Quick contact"
      >
        {open ? <X className="h-6 w-6" /> : <WhatsAppIcon className="h-7 w-7" />}
      </button>
    </div>
  );
};
